import { render, staticRenderFns } from "./paba-login.vue?vue&type=template&id=278f7dff&scoped=true&lang=pug"
import script from "./paba-login.vue?vue&type=script&lang=js"
export * from "./paba-login.vue?vue&type=script&lang=js"
import style0 from "./paba-login.vue?vue&type=style&index=0&id=278f7dff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f7dff",
  null
  
)

export default component.exports